import { render, staticRenderFns } from "./wine-academy.vue?vue&type=template&id=67f61dd9&scoped=true"
import script from "./wine-academy.vue?vue&type=script&lang=js"
export * from "./wine-academy.vue?vue&type=script&lang=js"
import style0 from "./wine-academy.vue?vue&type=style&index=0&id=67f61dd9&prod&scoped=true&lang=css"
import style1 from "./wine-academy.vue?vue&type=style&index=1&id=67f61dd9&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f61dd9",
  null
  
)

export default component.exports